export default function () {
  if (window.location.hostname === "localhost") {
    return window.location.host;
  } else if (window.location.hostname === "www.dojodevmojo.com") {
    return `https://www.dojodevmojo.com`;
  } else {
    return `https://www.dojomojo.com`;
  }
}
